import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        user_id: "",
        appid: "",
        phone: ""
      },
      rules: {
        phone: [{
          required: true,
          message: "请输入手机号码",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  _this.formData.user_id = data.user_id;
                  _this.formData.appid = data.appid; //获取当前用户是否已存在关联的手机号

                  _this.$api.getUserByPhone(_objectSpread(_objectSpread({}, _this.formData), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      if (res.data) {
                        _this.formData.phone = res.data;
                      }
                    }

                    _this.copyData();

                    _this.dialogFormVisible = true;
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 7;
                    break;
                  }

                  if (/^1[3-9]\d{9}$/.test(_this2.formData.phone)) {
                    _context2.next = 4;
                    break;
                  }

                  _this2.$message.error('手机号码不正确');

                  return _context2.abrupt("return");

                case 4:
                  _this2.$api.otherUpdatePhone(_objectSpread(_objectSpread({}, _this2.formData), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                  _context2.next = 8;
                  break;

                case 7:
                  return _context2.abrupt("return", false);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};